import React from "react";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, PageHeader } from "../../components/v3";
import { PurchaseOrderList } from "../../components/purchaseOrders/PurchaseOrderList";

export const PurchaseOrders = () => {
  const navigate = useNavigate();
  const handleAddClick = () => {
    navigate("/purchase-orders/create");
  };
  return (
    <PageLayout>
      {/* header section */}
      <PageHeader
        // title
        title="Purchase Orders"
        subtitle="286 purchase orders"
        // button
        buttons={[{ buttonText: "Create Order", buttonIcon: Add, onClick: handleAddClick }]}
      />

      {/* table section */}
      <CardLayout>
        <PurchaseOrderList />
      </CardLayout>
    </PageLayout>
  );
};
